<template>
  <div class="layout-component-wrap">
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="left-top">
          <border-comp-2>
            <slot name="left-top"></slot>
          </border-comp-2>
        </div>
        <div class="left-bottom">
          <border-comp-2>
            <slot name="left-bottom"></slot>
          </border-comp-2>
        </div>
      </el-col>
      <el-col :span="12">
        <border-comp-2 custom-class="right-wrap">
          <slot name="right"></slot>
        </border-comp-2>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BorderComp2 from '@/components/border-comp2';

export default {
  components: {
    BorderComp2
  }
};
</script>

<style lang="scss" scoped>
.layout-component-wrap {
  height: 100%;
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
    }
  }
  .left-top {
    height: 130px;
    margin-bottom: 20px;
    overflow: hidden;
  }
  .left-bottom {
    height: calc(100% - 150px);
    overflow: hidden;
  }
  .right-wrap {
    overflow: hidden;
  }
}
</style>
